import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import type { FilterGroup } from 'src/types/myFollowUp';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

export const useKPIFilterGroupQuery = (
  surveyId: number | undefined,
  orgUnitIds: string[] | undefined,
) => {
  const { i18n } = useTranslation();
  const endpoint = generatePath(apiPaths.MY_FOLLOW_UP.KPIS);

  return useQuery<FilterGroup>({
    queryKey: [endpoint, surveyId, orgUnitIds, i18n.language],
    enabled: !!surveyId && !!orgUnitIds && orgUnitIds?.length > 0,
    queryFn: ({ signal }) =>
      HttpService.get(
        endpoint,
        { survey_id: surveyId, org_unit_ids: orgUnitIds?.join(',') },
        true,
        { signal },
      )
        .then((data) => Promise.resolve(data.data))
        .catch(({ response }) => Promise.reject(response.status)),
  });
};

export default useKPIFilterGroupQuery;
